
import { Navbar } from "@/components/Navbar";

export default function Privacy() {
  return (
    <>
      <Navbar />
      <div className="container mx-auto py-12 px-4">
        <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="lead">
            At VitaWellness, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, 
            and safeguard your information when you use our service.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">1. Information We Collect</h2>
          <p>
            <strong>Personal Data:</strong> When you register for an account, we collect your email address, name, and other profile information.
          </p>
          <p>
            <strong>Health and Wellness Data:</strong> We collect information related to your wellness goals, exercise habits, nutrition intake, 
            sleep patterns, and other wellness-related data that you provide.
          </p>
          <p>
            <strong>Usage Data:</strong> We collect information on how you interact with our service, including access times, pages viewed, 
            and features used.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">2. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Provide, maintain, and improve our services</li>
            <li>Process transactions and send related information</li>
            <li>Generate personalized wellness recommendations</li>
            <li>Send administrative messages, updates, and promotional content</li>
            <li>Monitor and analyze usage patterns and trends</li>
            <li>Detect, investigate, and prevent fraudulent transactions and unauthorized access</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">3. Data Sharing and Disclosure</h2>
          <p>We may share your information with:</p>
          <ul>
            <li>Service providers who perform services on our behalf</li>
            <li>Partners with whom we offer co-branded services or promotions</li>
            <li>Legal and regulatory authorities, as required by law</li>
          </ul>
          <p>
            We will not sell or rent your personal information to third parties for marketing purposes without your explicit consent.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">4. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your personal data against unauthorized or 
            unlawful processing, accidental loss, destruction, or damage.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">5. Data Retention</h2>
          <p>
            We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, 
            unless a longer retention period is required or permitted by law.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">6. Your Rights</h2>
          <p>Depending on your location, you may have the right to:</p>
          <ul>
            <li>Access the personal information we hold about you</li>
            <li>Correct inaccurate or incomplete data</li>
            <li>Request deletion of your personal information</li>
            <li>Restrict or object to our processing of your data</li>
            <li>Request transfer of your personal information</li>
            <li>Withdraw consent where processing is based on consent</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">7. Children's Privacy</h2>
          <p>
            Our service is not intended for individuals under the age of 18. We do not knowingly collect personal information from children.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">8. Changes to This Privacy Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page 
            and updating the "Last Updated" date.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">9. Contact Us</h2>
          <p>
            If you have questions or concerns about this Privacy Policy, please contact us at privacy@vitawellness.com.
          </p>

          <p className="mt-12 mb-6">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>
    </>
  );
}
